import { Button, Input, Typography, notification } from 'antd';
import { useState, default as React } from 'react';
import { FetchFromBackend, ErrorConnectionFailed } from './HelperContactBackend';
import TikTokLogo from './Images/TikTokLogo.png';
import InstagramLogo from './Images/InstagramLogo.png';
import YouTubeLogo from './Images/YouTubeLogo.png';
import './Stepper.css';
import validator from 'validator';
import md5 from 'md5';
const { Text } = Typography;
const { Search } = Input;

export const PickerPlatform = ({ next, payingParticipants, setPlatform, setSessionId, setEmailIdentifier, useMobileVersion }) => {

    // Used seperately because of the asynchronous nature of hooks.
    const [emailIdentifierLocal, setEmailIdentifierLocal] = useState("");
    const [numDonations, setNumberDonations] = useState(null);
    
    // Expects a string
    function onClick(platform) {

        // console.log("total number of tiktok donations", numDonations['num_donations_tiktok_total']);
        // console.log("total number of youtube donations", numDonations['num_donations_youtube_total']);

        if(numDonations['num_donations_tiktok_total'] > 435) {
            openDonationsFulfilled();
            setEmailIdentifierLocal("");
        }
        else if(numDonations['num_donations_'+platform] > 0){
            openDonationExists();
            setEmailIdentifierLocal("");
        }
        else {
            setPlatform(platform);
            // console.log("EmailIdentifierLocal= " + emailIdentifierLocal + " 2");
            setEmailIdentifier(emailIdentifierLocal);
            FetchFromBackend('session_ids/',
                next,
                ErrorConnectionFailed,
                setSessionId);
        }
    };

    const openDonationExists = () => {
        notification["error"]({
            message: <Text strong>{'Donation with this email exists'}</Text>,
            className: "Text",
            description:
                <div>
                    <Text>{"We already received a donation for this specific email. Please specify another email."}</Text>
                </div>,
        });
    };

    const openDonationsFulfilled = () => {
        notification["error"]({
            message: <Text strong>{'Enough donations received'}</Text>,
            className: "Text",
            description:
                <div>
                    <Text>{"We already received enough donations for this round of data collection."}</Text>
                </div>,
        });
    };
    
    const openNotificationEmailSet = (email) => {
        notification["success"]({
            message: <Text strong>{'Email Succesfully Set!'}</Text>,
            description:
                "Your email (" + email+ ") has been successfully set!",
        });
    };
    
    const openEmailRejected = (email) => {
        notification["error"]({
            message: <Text strong>{'Error when setting your email!'}</Text>,
            className: "Text",
            description:
                <div>
                    <Text>{"The provided email is not valid.\n"}</Text>
                    <Text strong>{"Provided Email: " + email}</Text>
                </div>,
        });
    };

    const openEmailRejectedQualtrics = () => {
        notification["error"]({
            message: <Text strong>{'Error!'}</Text>,
            className: "Text",
            description:
                <div>
                    <Text>{"We are currently accepting donations only from people that already expressed interest via our Qualtrics survey.\n"}</Text>
                </div>,
        });
    };

    return (
        
        <div>
            <div hidden={!payingParticipants} className={"PidInput"}>
                <Text>Please enter your Prolific email address (Prolific_ID@email.prolific.com):</Text>
                <Search
                    type="email"
                    
                    onSearch={(e) => { 
                        if (e !== null && e !== "") {
                            if (validator.isEmail(e)){
                                e = e.toLowerCase();

                                if (e.length != 43 || !e.endsWith("@email.prolific.com")) {
                                    openEmailRejected(e);
                                } else {
                                    FetchFromBackend('donations/email/' + md5(e),
                                    ()=>{},
                                    () => {
                                        ErrorConnectionFailed();
                                    },
                                    setNumberDonations)
                                    setEmailIdentifierLocal(e);
                                    openNotificationEmailSet(e);
                                }
                            }
                            else{
                                if(emailIdentifierLocal==""){
                                    openEmailRejected(e);
                                }
                            }
                        
                    }}}
                    enterButton="Set"
                    placeholder={emailIdentifierLocal}/>
            </div>
            <div align="center">
                <Button disabled={emailIdentifierLocal === ""} className={useMobileVersion ? "PlatformSelectButtonMobile" : "PlatformSelectButton"} onClick={() => { onClick("tiktok") }}>
                    <div>
                        <Text className={useMobileVersion ? "PlatformSelectTextMobile" : "PlatformSelectText"}>Begin the donation of your data from</Text>
                    </div>
                    <div>
                        <img className={useMobileVersion ? "PlatformSelectImageMobile" : "PlatformSelectImage"} src={TikTokLogo} />
                    </div>
                </Button>
                <Button disabled={emailIdentifierLocal === ""} className={useMobileVersion ? "PlatformSelectButtonMobile" : "PlatformSelectButton"} onClick={() => { onClick("youtube") }}>
                    <div>
                        <Text className={useMobileVersion ? "PlatformSelectTextMobile" : "PlatformSelectText"}>Begin the donation of your data from</Text>
                    </div>
                    <div>
                        <img className={useMobileVersion ? "PlatformSelectImageMobile" : "PlatformSelectImage"} src={YouTubeLogo} />
                    </div>
                </Button>
                <Button disabled={emailIdentifierLocal === ""} className={useMobileVersion ? "PlatformSelectButtonMobile" : "PlatformSelectButton"} onClick={() => { onClick("instagram") }}>
                    <div>
                        <Text className={useMobileVersion ? "PlatformSelectTextMobile" : "PlatformSelectText"}>Begin the donation of your data from</Text>
                    </div>
                    <div>
                        <img className={useMobileVersion ? "PlatformSelectImageMobile" : "PlatformSelectImage"} src={InstagramLogo} />
                    </div>
                </Button>
            </div>
        </div>
    )
};

export default PickerPlatform;
